export default "__VITE_ASSET__CmqH3Jv5__"